import { get, isEmpty, set } from 'lodash/fp';

const createSimpleValidator = (condition, errorString) =>
    (field) =>
        (errors, values) => (!condition(get(field, values)) && !isEmpty(get(field, values))
            ? set(field, errorString, errors)
            : errors);

export default createSimpleValidator;
